import { render, staticRenderFns } from "./account-activation-success-design-form.vue?vue&type=template&id=276ed59c"
import script from "./account-activation-success-design-form.vue?vue&type=script&lang=js"
export * from "./account-activation-success-design-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports